export default __webpack_public_path__ + "static/media/rightArrowUp.e1cc824b.svg";